import { render, staticRenderFns } from "./VoucherTableHead.vue?vue&type=template&id=72a8b26e"
import script from "./VoucherTableHead.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherTableHead.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports